import { render } from "./AppBetslip.vue?vue&type=template&id=6d62d979"
import script from "./AppBetslip.vue?vue&type=script&lang=js"
export * from "./AppBetslip.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__